import { Alert, Button, Typography } from 'antd';

/**
 * Pemberitahuan pemakaian pertama (asisten-ai-cs.md §7.2). Persetujuan disimpan di localStorage
 * per username (keputusan E2) — muncul lagi di PC/browser lain; pencatatan di server menyusul R2.
 */
export function LayarPersetujuan({ onSetuju }: { onSetuju: () => void }) {
  return (
    <div style={{ padding: 'var(--spacing-lg)' }}>
      <Typography.Title level={5}>Sebelum memakai Asisten Booku</Typography.Title>
      <ul style={{ paddingLeft: 'var(--spacing-lg)', fontSize: 'var(--font-size-sm)' }}>
        <li>Jawaban disusun dari <b>panduan resmi Booku</b> dan disertai tautan sumbernya. Asisten adalah AI dan bisa keliru — periksa panduan yang ditautkan bila ragu.</li>
        <li><b>Jangan menempelkan data pribadi</b> karyawan atau pelanggan (NIK, NPWP, nomor rekening, password). Pertanyaan Anda diproses oleh penyedia AI pihak ketiga.</li>
        <li>Penjelasan akuntansi & pajak bersifat umum. <b>Keputusan atau angka pajak final tetap ke konsultan pajak Anda.</b></li>
        <li>Bila Asisten tidak bisa membantu, pertanyaan dapat diteruskan ke tim CS lewat WhatsApp.</li>
      </ul>
      <Alert type="info" showIcon title="Riwayat percakapan disimpan untuk perbaikan layanan dan dapat Anda hapus kapan saja." />
      <Button type="primary" block style={{ marginTop: 'var(--spacing-md)' }} onClick={onSetuju}>
        Saya mengerti
      </Button>
    </div>
  );
}
